 
import '../static/form.css';
import React, { useState, useEffect  } from "react";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import HistoryGromming from '../components/HistoryGromming';

const IndexFormName = () => {
    const [formData, setFormData] = useState({
         name: '',
        phone: ''
      });
  const [responseMessage ,setResponseMessage] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [selectedPetId, setSelectedPetId] = useState(null);
  const navigate = useNavigate(); // React Router hook for navigation

    
  
  // Function to fetch pet names for autocomplete
  const fetchSuggestions = async (query) => {
    try {
    const response = await fetch(`/autocomplete-pet-names/?query=${query}`);
    const data = await response.json();
    setSuggestions(data.suggestions || []);
  } catch (error) {
    alert('Error fetching Telephone:', error);
    console.error('Error fetching Telephone:', error);
  }
  };


  // Fetch autocomplete suggestions when the name input changes
const handleNameChange = async (e) => {
  const { value } = e.target;
  setFormData((prevState) => ({
    ...prevState,
    name: value,
    phone: '',   // <-- update name here, not name
  }));

  if (value.length > 2) {
    fetchSuggestions(value);
  } else {
    setSuggestions([]);
  }
};
  
  const handleSuggestionClick = (suggestion) => {
    setFormData((prevState) => ({
      ...formData,
      name: suggestion.name,
    phone: suggestion.phone,
    }));
    setSuggestions([]); // Clear suggestions after selecting one
  };

    // Handle change in other input fields (e.g., owner's name)
    const handleChange = (e) => {
      const { name, value } = e.target;  // e.target doesn't have 'name' attribute, so this will be undefined
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,   // this won't work as expected
      }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { phone } = formData;

        try {
        const queryParams = new URLSearchParams({ phone }).toString();
      
        const response = await fetch(`/fetch-pet/?${queryParams}`);

          if (!response.ok) {
            setResponseMessage('Pet not found.');
            return;
          }

          const data = await response.json();

          // Safely build URL query string for navigation
          const query = new URLSearchParams({
            id: data.id || '',
            name: data.name || '',
            catdog: data.catdog || '',
            owner: data.owner || '',
            image: data.image || '',
            phone: data.phone || '',
            breed: data.breed || '',
            age: data.age?.toString() || '',
            behaviour: data.behaviour || '',
            allergies: data.allergies || '',
            vaccinated: data.vaccinated?.toString() || '',
            grooming_history: data.grooming_history || '',
            booking_date: data.booking_date || '',
            extra_info: data.extra_info || '',
            text: data.text || ''
          }).toString();

          navigate(`/historygroom/?${query}`);
          } catch (error) {
          console.error('Error fetching pet:', error);
          setResponseMessage('An error occurred. Please try again.');
          }
          };
      
  
    return (
      <section className="contact-wrap">
       <form className="contact-form" onSubmit={handleSubmit}>
        <label>Name of Pet</label>
        <div className="input-block">
            <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleNameChange}
            className="form-control"
            autoComplete="off"
            />

            <input
            name="phone"
            value={formData.phone}
            className="form-control"
            readOnly
            />

            {suggestions.length > 0 && (
            <div className="autocomplete-suggestions">
                {suggestions.map((suggestion) => (
                <div className="input-block" key={suggestion.id}>
                    <input
                    type="text"
                    className="form-control mt-1"
                    value={`${suggestion.name} (${suggestion.phone})`}
                    onClick={() => handleSuggestionClick(suggestion)}
                    readOnly
                    />
                </div>
                ))}
            </div>
            )}
        </div>

        <div className="mt-3">
            <button type="submit" className="square-button">Find Out</button>
        </div>
        </form>

  
        {responseMessage && <p className="response-message">{responseMessage}</p>}
      </section>
    );
  };
  
export default IndexFormName;

  